module.exports = __webpack_public_path__ + "static/media/myfreecams.6cafbbb9.png";